'use client';

import { useState } from 'react';
import { useEvent } from '../common/useEvent';
import { IoIosWarning } from 'react-icons/io';
import PFParagraph from './PFParagraph';
import { IoIosArrowForward } from 'react-icons/io';
import Spinner from './Spinner';
import PFLink from './PFLink';
import * as stylex from '@stylexjs/stylex';
import '@/common/tokens.stylex';
import { colors } from '@/common/tokens.stylex';
type Props = {
  jobs: {
    id: number;
    title: string;
    internal_job_id?: number;
  }[];
  withJobSelecting?: boolean;
};
const defaultError = 'Deine Bewerbung konnte gerade nicht abgeschickt werden, versuche es bitte später noch einmal.';
const JobsForm = (props: Props) => {
  const {
    jobs,
    withJobSelecting
  } = props;
  const [vorname, setVorname] = useState('');
  const [nachname, setNachname] = useState('');
  const [email, setEmail] = useState('');
  const [file, setFile] = useState<File | null>(null);
  const [formCompletitionStep, setFormCompletitionStep] = useState(0);
  const [selectedJob, setSelectedJob] = useState(jobs?.length > 0 ? props?.jobs[0]?.id : {});
  const [error, setError] = useState<String | undefined>();
  const [loading, setLoading] = useState(false);
  const handleSubmit = useEvent(async () => {
    setLoading(true);
    const jobId = withJobSelecting ? selectedJob : jobs[0].internal_job_id;
    let postUrl = '';
    let getUrl = '';
    if (file) {
      const splittedFile = file.name.split('.');
      if (splittedFile.length < 2) {
        setLoading(false);
        setError('Die Datei muss eine .pdf oder .zip Dateierweiterung haben');
        return;
      }
      const fileExt = splittedFile[splittedFile.length - 1];
      if (fileExt !== 'pdf' && fileExt !== 'zip') {
        setLoading(false);
        setError('Die Datei muss eine .pdf oder .zip Dateierweiterung haben');
        return;
      }
      const presignedResponse = await fetch('/api/getPresignedUrl/', {
        method: 'POST',
        body: JSON.stringify({
          fileExtension: fileExt
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (presignedResponse.status !== 200) {
        setError(defaultError);
        setLoading(false);
        return;
      }
      const urls = await presignedResponse.json();
      postUrl = urls.postUrl;
      getUrl = urls.getUrl;
    }
    if (postUrl) {
      try {
        const amazonResponse = await fetch(postUrl, {
          method: 'PUT',
          body: file
        });
        if (amazonResponse.status !== 200) {
          setError(defaultError);
          setLoading(false);
          return;
        }
      } catch (error) {
        setError(defaultError);
        setLoading(false);
        return;
      }
    }
    const body = {
      prospect: 'false',
      first_name: vorname,
      last_name: nachname,
      emails: [{
        email: email,
        type: 'personal'
      }],
      job_id: jobId,
      external_id: Math.floor(Math.random() * 10000000),
      ...(getUrl && {
        resume: getUrl
      })
    };
    fetch('/api/sendApplication', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(response => {
      if (response.status === 200) {
        return response.json();
      } else {
        setError(defaultError);
        setLoading(false);
      }
    }).then(jsonData => {
      if (jsonData.message === 'Application successful') {
        setVorname('');
        setNachname('');
        setEmail('');
        setFormCompletitionStep(2);
        setLoading(false);
      } else {
        setError(defaultError);
        setLoading(false);
      }
    }).catch(() => {
      setLoading(false);
      setError(defaultError);
    });
  });
  return <div>
      {formCompletitionStep !== 2 && <h2 className="x1yztbdb x1aegnp4 xxmjlet">Jetzt bewerben</h2>}
      {formCompletitionStep === 0 && <form onSubmit={e => {
      e.preventDefault();
      setFormCompletitionStep(1);
    }}>
          {withJobSelecting && jobs?.map(job => <ul key={job.id} className="xh8yej3 xxbde42">
                <li key={job.id} className="xh8yej3 xdpxx8g xod5an3 x1pgnn3v xc7ga6q xghm5j0 x1nkuoye x4pepcl x1n2onr6 x1ypdohk" onClick={() => setSelectedJob(job.id)}>
                  <div className="x10l6tqk xy5igu8 x16sl8bf" />
                  <div className="x78zum5 xc26acl x1vynn30 x6s0dn4">
                    <input type="radio" name="job" checked={selectedJob === job.id} className="xjyslct xamitd3 x1ypdohk x1db2dqx x1kky2od xlup9mm x10hpsqq xmkeg23 x1y0btm7 xh3icha x1pgnn3v x1ot5i8h" id={job.id} onChange={() => setSelectedJob(job.id)} required />
                    <label htmlFor={job.id} className="x845mor x1vynn30 x1ducrmg x1ypdohk">
                      {job.title}
                    </label>
                    <PFLink href={'/jobs/' + job?.title.toLowerCase().trim().replace(/\s+/g, '-') + '/'} style={styles.jobLink} title={`Zu ${job.title}`}>
                      <IoIosArrowForward className="x1vynn30 x1td3qas x1277o0a" />
                    </PFLink>
                  </div>
                </li>
              </ul>)}
          <div className="x10l6tqk xy5igu8 x16sl8bf" />
          <label className="xxmjlet x1lliihq x12ulsxz x1nkuoye x1ducrmg" htmlFor="name">
            Vorname: <br />
          </label>
          <input required name="vorname" type="text" autoComplete="given-name" value={vorname} onChange={e => setVorname(e.target.value)} className="xjyslct xh8yej3 xxbde42 x1vynn30 x1ducrmg x4pepcl x1pgnn3v xmkeg23 x1y0btm7 x1l0h3s4 x1vvogim xaope02" id="name" />{' '}
          <br />
          <label className="xxmjlet x1lliihq x12ulsxz x1nkuoye x1ducrmg" htmlFor="surname">
            Nachname: <br />
          </label>
          <input required name="nachname" type="text" autoComplete="family-name" value={nachname} onChange={e => setNachname(e.target.value)} className="xjyslct xh8yej3 xxbde42 x1vynn30 x1ducrmg x4pepcl x1pgnn3v xmkeg23 x1y0btm7 x1l0h3s4 x1vvogim xaope02" id="surname" />
          <br />
          <label className="xxmjlet x1lliihq x12ulsxz x1nkuoye x1ducrmg" htmlFor="email">
            Email: <br />
          </label>
          <input required name="email" type="email" autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} className="xjyslct xh8yej3 xxbde42 x1vynn30 x1ducrmg x4pepcl x1pgnn3v xmkeg23 x1y0btm7 x1l0h3s4 x1vvogim xaope02" id="email" />
          <br />
          <label htmlFor="fileInput" className="xxmjlet x1lliihq x12ulsxz xxxqvl3 x1ducrmg x1ypdohk">
            <PFParagraph style={styles.fileCopy}>
              Lade hier deinen Lebenslauf als PDF hoch. Falls du mehrere Dateien
              anhängen möchtest, dann erstelle eine .zip Datei und lade sie hier
              hoch.
            </PFParagraph>
          </label>
          <input id="fileInput" type="file" name="file" accept=".pdf,.zip" onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
        setFile(e.target.files[0]);
      }} className="x193iq5w x1ypdohk xxmjlet x1ducrmg" />
          <div className="x78zum5 x1q0g3np x6s0dn4 x167g77z x1xmf6yo">
            <input required type="checkbox" name="dsgvo" className="xvy4d1p xxk0z11 x1ypdohk" id="link-checkbox" />
            <label htmlFor="link-checkbox" className="xxmjlet x1lliihq x12ulsxz x1nkuoye x1ducrmg x1ypdohk">
              Ich akzeptiere die{' '}
              <PFLink href="/datenschutzerklaerung/" style={styles.privacyLink}>
                Datenschutzerklärung
              </PFLink>{' '}
              <br />
            </label>
          </div>
          <input type="submit" value="Abschicken" className="xw7yly9 x16yqafl x4pepcl xh8yej3 xxbde42 xng3xce x6bodad xx35cyf xisb524 x1pgnn3v xlxv5dc x16mnge6 xc7ga6q x1j61zf2 xnfc8uc x1s688f x2b8uid xamitd3 x10fmesz xz4gly6 x1d8287x x1ypdohk" />
        </form>}
      {formCompletitionStep === 1 && <>
          <PFParagraph style={styles.summary}>
            {withJobSelecting && <>
                Job: <b>{jobs.find(job => job.id === selectedJob)?.title}</b>
                <br />
              </>}
            Vorname: <b>{vorname}</b> <br />
            Nachname: <b>{nachname}</b> <br />
            Email: <b>{email}</b> <br />
            {file && <>
                <b>Anhang: </b>
                <span className="xxmjlet" key={file.name}>
                  {file.name}
                </span>
              </>}
            <span className="x12oqio5 x1lliihq xxmjlet x1xlr1w8 x1ducrmg">
              Sind die Angaben korrekt?
            </span>
          </PFParagraph>
          {error && <div className="x78zum5 x1q0g3np x6s0dn4 x167g77z xsag5q8">
              <IoIosWarning className="xxmjlet x1vqgdyp x100vrsf" />
              <div className="x4pepcl x1lliihq xxmjlet x1xlr1w8 x1ducrmg">{error}</div>
            </div>}
          <button onClick={handleSubmit} className="x1lliihq x4pepcl xsdox4t xieb3on xh8yej3 xxbde42 xng3xce x6bodad xemggz9 x644a3x x1pgnn3v x1ambbbv xuqe75f xc7ga6q x1j61zf2 xnfc8uc x1s688f x2b8uid xamitd3 x10fmesz xz4gly6 x1d8287x xm4lit0" disabled={loading}>
            {loading && <div className="xh8yej3 x78zum5 xl56j7k">
                <Spinner />
              </div>}
            {!loading && 'Abschicken'}
          </button>
          <button onClick={() => {
        setFormCompletitionStep(0);
        setError(defaultError);
        setFile(null);
      }} className="x1lliihq x4pepcl xsdox4t xieb3on xh8yej3 xxbde42 xng3xce x6bodad xemggz9 x644a3x x1pgnn3v x1ambbbv xuqe75f xc7ga6q x1j61zf2 xnfc8uc x1s688f x2b8uid xamitd3 x10fmesz xz4gly6 x1d8287x xm4lit0 x3nkca4" disabled={loading}>
            Bearbeiten
          </button>
        </>}
      {formCompletitionStep === 2 && <h2 className="xxmjlet">
          Danke für deine Bewerbung, wir melden uns bald!
        </h2>}
    </div>;
};
export default JobsForm;
const styles = {
  jobLink: {
    k1xSpc: "x78zum5",
    kzqmXN: "x100vrsf",
    kZKoxP: "x1vqgdyp",
    kGNEyG: "x6s0dn4",
    kjj79g: "xl56j7k",
    $$css: true
  },
  fileCopy: {
    kGuDYH: "x1ducrmg",
    kMwMTN: "xxmjlet",
    $$css: true
  },
  privacyLink: {
    kMwMTN: "xxmjlet xp9cbwy",
    kybGjl: "x1bvjpef",
    kcSHmL: "x3pynha",
    $$css: true
  },
  summary: {
    kMwMTN: "xxmjlet",
    kGuDYH: "x1ducrmg",
    $$css: true
  }
};